import React, {useState} from "react";
import {
    Box,
    Dialog,
    Typography,
    IconButton,
    TextField,
    Button,
    FormControlLabel,
    Checkbox,
    Link,
    useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
import useForgotPassword from "../../../hooks/login/useForgotPassword";
import {useTranslation} from "react-i18next";
import {PAGE_LOGIN} from "../../../locales/pages/namespaces";

export default function ForgotPasswordModal({ open, onClose }) {
    const { formik } = useForgotPassword({onClose});
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const { t } = useTranslation(PAGE_LOGIN)


    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullScreen={isMobile}
            fullWidth
            PaperProps={{
                sx: {
                    width: isMobile ? "100%" : 520,
                    maxWidth: isMobile ? "100%" : "95vw",
                    m: isMobile ? 0 : 2,
                    borderRadius: isMobile ? 0 : "20px",
                    bgcolor: "#F0F0F0",
                    overflow: "hidden",
                },
            }}
        >
            <Box
                sx={{
                    position: "relative",
                    p: { xs: 2, sm: 2.5 },
                    pt: { xs: 6, sm: 2.5 },
                    minHeight: isMobile ? "100vh" : "auto",
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                <IconButton
                    onClick={onClose}
                    sx={{
                        position: "absolute",
                        top: { xs: 12, sm: 10 },
                        right: { xs: 12, sm: 10 },
                        width: 42.11,
                        height: 40.88,
                        borderRadius: "30px",
                        bgcolor: "#FBFBFB",
                        "&:hover": { bgcolor: "#FBFBFB" },
                    }}
                >
                    <CloseIcon sx={{ color: "#111111" }} />
                </IconButton>

                <Box
                    component="form"
                    onSubmit={formik.handleSubmit}
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: { xs: 2, sm: 2.5 },
                    }}
                >
                    <Typography
                        sx={{
                            fontFamily: "'Zen Maru Gothic', sans-serif",
                            fontWeight: 900,
                            fontSize: { xs: 20, sm: 24 },
                            textTransform: "uppercase",
                            color: "#111",
                        }}
                    >
                        ΞΕΧΑΣΑΤΕ ΤΟΝ ΚΩΔΙΚΟ ΣΑΣ ;
                    </Typography>

                    <Typography
                        sx={{
                            fontFamily: "'Roboto Condensed', sans-serif",
                            fontSize: { xs: 13, sm: 14 },
                            lineHeight: "120%",
                        }}
                    >
                        Παρακαλούμε πληκτρολογίστε το email που χρησιμοποιήσατε κατά την εγγραφή σας.Στην συνέχεια Θα σας στείλουμε τον καινούργιο σας κωδικό.
                    </Typography>

                    <Box sx={{ display: "flex", flexDirection: "column", gap: 1.25 }}>
                        <TextField
                            {...formik.getFieldProps("email")}
                            fullWidth
                            variant="outlined"
                            size="small"
                            name="email"
                            value={formik.values.email}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.email && Boolean(formik.errors.email)}
                            helperText={formik.touched.email && formik.errors.email}
                            placeholder="email"
                            InputLabelProps={{
                                sx: {
                                    fontFamily: "'Zen Maru Gothic', sans-serif",
                                    fontSize: 14,
                                    color: "#111111",
                                    "&.Mui-focused": {
                                        color: "#111111",
                                    },
                                },
                            }}
                            InputProps={{
                                sx: {
                                    fontFamily: "'Zen Maru Gothic', sans-serif",
                                    fontSize: 14,
                                    "& .MuiInputBase-input": {
                                        py: 1.1,
                                        pl: 1,
                                    },
                                    "& fieldset": {
                                        borderColor: "#111111",
                                        borderWidth: 1,
                                        borderRadius: "4px",
                                    },
                                    "&:hover fieldset": {
                                        borderColor: "#111111",
                                    },
                                    "&.Mui-focused fieldset": {
                                        borderColor: "#111111",
                                    },
                                },
                            }}
                        />

                    </Box>

                    <Button
                        type="submit"
                        fullWidth={isMobile}
                        sx={{
                            width: isMobile ? "100%" : 150,
                            height: 37,
                            borderRadius: "120px",
                            bgcolor: "#E5007E",
                            "&:hover": { bgcolor: "#E5007E" },
                            fontFamily: "'Zen Maru Gothic', sans-serif",
                            fontWeight: 700,
                            fontSize: 12,
                            color: "#FCFCFC",
                            alignSelf: isMobile ? "stretch" : "flex-start",
                            mt: 0.5,
                        }}
                    >
                        ΑΝΑΚΤΗΣΗ ΚΩΔΙΚΟΥ
                    </Button>
                </Box>
            </Box>
        </Dialog>
    );
}


